import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/not-found/ui/NotFoundPage.tsx");
